export default __webpack_public_path__ + "static/media/BlueBg.e85bc3c8.svg";